// extracted by css-extract-rspack-plugin
module.exports =  {"congrats":"Congrats__congrats___XutWS"};